import {WorkflowItemKeyDirective} from '@workflow/directives/workflow-item-key/workflow-item-key.directive';
import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {Subscription} from 'rxjs';

@Component({
	selector: 'workflow-abstract-missing-value-button',
	template: ``,
})
export abstract class AbstractMissingValueComponent implements OnInit, OnDestroy {
	hasMissingValue: boolean;
	showMissingValueModal: boolean;
	finishedAndLocked: boolean;

	private subscription = new Subscription();

	@Output() entrySelected = new EventEmitter<void>();
	@Output() missingValueChanged = new EventEmitter<boolean>(true);

	protected constructor(private workflowItemKey: WorkflowItemKeyDirective) {
	}

	public ngOnInit(): void {
		this.subscription.add(this.workflowItemKey.property$.subscribe(data => {
			if (!this.finishedAndLocked) {
				this.updateMissingValueData(data);
			}
		}));
		this.subscription.add(this.workflowItemKey.propertyFull$.subscribe(data => {
			if (this.finishedAndLocked) {
				this.updateMissingValueData(data);
			}
		}));
	}
	public ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	private updateMissingValueData(data: unknown): void {
		this.hasMissingValue = !!data;
		this.missingValueChanged.emit(this.hasMissingValue);
	}

	enableMissingValue(): void {
		this.workflowItemKey.setProperty(true);
		this.closeMissingValueModal();
	}
	disableMissingValue(): void {
		this.workflowItemKey.setProperty(false);
		this.closeMissingValueModal();
	}

	closeMissingValueModal(): void {
		this.showMissingValueModal = false;
		this.entrySelected.emit();
	}

	toggleMissingValue(): void {
		if (!this.hasMissingValue) {
			this.showMissingValueModal = true;
			return;
		}

		this.disableMissingValue();
	}
}
